import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { QueryFiltersDomainOnly } from '../types';
import { RiskyIndicator } from '../../types';
import { buildUniversalMfaDomainQueryParams } from '../constants/utils';
import { universalMFAQueryKeys } from '../constants/queryKeys';

const END_POINT = '/metric/riskyIndicators';
const LIMIT = 9;

type RiskyIndicatorsDto = RiskyIndicator;

const convertToRiskyIndicators = (data: RiskyIndicatorsDto[]): RiskyIndicator[] => {
    return data.map((item) => ({
        name: item.name,
        value: item.value
    }));
};

const fetchRiskyIndicators = async (filters: QueryFiltersDomainOnly): Promise<RiskyIndicatorsDto[]> => {
    const data = await apiGet<RiskyIndicatorsDto[]>(`${API_BASE_URL}${END_POINT}`, {
        ...buildUniversalMfaDomainQueryParams(filters),
        limit: LIMIT.toString()
    });
    return data;
};

export const useRiskyIndicators = (filters: QueryFiltersDomainOnly): UseQueryResult<RiskyIndicator[]> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.riskyIndicators(filters),
        queryFn: () => fetchRiskyIndicators(filters),
        select: convertToRiskyIndicators
    });
};
